export const sampleData =[{
    identityPoolID:"1",
    identityPoolName:"Test1",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},{
    identityPoolID:"2",
    identityPoolName:"Test2",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},{
    identityPoolID:"3",
    identityPoolName:"Test3",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},{
    identityPoolID:"4",
    identityPoolName:"Test1",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},{
    identityPoolID:"5",
    identityPoolName:"Test2",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},{
    identityPoolID:"6",
    identityPoolName:"Test3",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},{
    identityPoolID:"7",
    identityPoolName:"Test2",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},{
    identityPoolID:"8",
    identityPoolName:"Test3",
    tenantCount:4,
    tenants:[],
    clientCount:3,
    client:[],
    clientCount:2,
    users:[],
    userCount:5,
},]